import { Box, Button, LinearProgress, Stack, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useGetProductsQuery } from "src/api/services/productsApi";
import { useMemo } from "react";
import { CATEGORY } from "src/constants/searchParams";
import { useSearchParams } from "react-router-dom";
import { filters } from "./utils/filters";
import Filter from "src/components/TableFilter";
import { useManageModal } from "src/hooks/useManageModal";
import CreateProductModal from "src/components/Modals/CreateProductModal";
import { useFromAndTo } from "src/hooks/useFromAndTo";
import { usePagination } from "src/hooks/usePagination";
import DataTable from "src/components/DataTable";
import { useColumns } from "./utils/columns";
import { useSelection } from "src/context/ItemsSelectionProvider/useSelection";
import Actions from "./components/Actions";
import TransferProductsModal from "./components/TransferProductsModal/TransferProductsModal";
import { useDrawerContext } from "src/context/drawers/ProductsDrawerProvider/ProductsDrawerProvider";

const Products = () => {
  const { handleOpenUpdateItem } = useDrawerContext();
  const columns = useColumns(handleOpenUpdateItem);
  const [params] = useSearchParams();
  const { from, to } = useFromAndTo();
  const pagination = usePagination();
  const [open, { handleClose, handleOpen }] = useManageModal();
  const [
    openTransfer,
    { handleClose: handleCloseTransfer, handleOpen: handleOpenTransfer },
  ] = useManageModal();
  const { selected } = useSelection();

  //104 header + filters
  //64 gaps
  //34 top and bottom padding
  const height = useMemo(
    () => window.innerHeight - 42 - 60 - 32 - 52 - 32 - 4,
    [],
  );

  const queryParams = useMemo(() => {
    return {
      category: params.get(CATEGORY) ?? undefined,
      from,
      to,
    };
  }, [from, params, to]);

  const { data, isFetching } = useGetProductsQuery(queryParams);

  const { products, count } = useMemo(() => {
    if (data == null) {
      return { products: [], count: 0 };
    }

    return { products: data.data, count: data.count };
  }, [data]);

  return (
    <Stack gap={2}>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h4" fontWeight={600}>
          Products
        </Typography>
        <Button startIcon={<AddIcon />} onClick={handleOpen}>
          Add New
        </Button>
      </Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        height={60}
        alignItems="center"
      >
        <Stack
          direction="row"
          gap="16px"
          flexWrap="wrap"
          width="100%"
          alignItems="center"
        >
          {selected.length > 0 ? (
            <Actions count={selected.length} handleOpen={handleOpenTransfer} />
          ) : (
            filters.map((filter) => (
              <Filter key={filter.name} current={filter} />
            ))
          )}
        </Stack>
      </Stack>
      <Stack gap={0}>
        <Box height={4}>
          {isFetching ? <LinearProgress color="success" /> : null}
        </Box>
        <DataTable
          columns={columns}
          data={products}
          total={count}
          primaryKey="id"
          height={height}
          pagination={pagination}
        />
      </Stack>
      <CreateProductModal onClose={handleClose} open={open} />
      <TransferProductsModal
        open={openTransfer}
        onClose={handleCloseTransfer}
      />
    </Stack>
  );
};

export default Products;
